import type { Extensions } from '@tiptap/react';

import Emoji from '@tiptap/extension-emoji';
import { TableKit } from '@tiptap/extension-table';

import { ImageNode, AudioNode, VideoNode } from '@/components/ui/tiptap/tiptap-node';

import { simpleExtensionSet } from '.';

/**
 * A set of default extensions for the Tiptap editor.
 * Includes Typography, resizable tables, text alignment for headings and paragraphs,
 * Base64 image support, a custom image upload node, and a drop cursor for drag-and-drop.
 */
export const defaultExtensionSet: Extensions = [
  ...simpleExtensionSet,
  TableKit.configure({
    table: { resizable: true, lastColumnResizable: false },
  }),
  Emoji.configure({
    enableEmoticons: true,
  }),
  ImageNode,
  AudioNode,
  VideoNode,
];
